import React from 'react';
import ReactDOM from 'react-dom';
import ContactPageContent from './ContactPageContent';

if (document.getElementById("ContactUsJson") !== null) {
    var contactUsJson = JSON.parse(document.getElementById("ContactUsJson").textContent); // eslint-disable-next-line
    ReactDOM.render(<ContactPageContent contactJson={contactUsJson.Model} />, document.getElementById('ContactUsIndex'));
}

